import React from "react";
import { useEffect, useState, useRef, useCallback, useMemo } from "react";
import { Col, Row } from "reactstrap";
import { useMediaQuery } from "react-responsive";
import { APILA } from "../../../../../config/apila";
import { APIMS } from "../../../../../config/apims";
import { faIdCard } from '@fortawesome/free-solid-svg-icons';
import "bulma/css/bulma.css";
import "../../../../../index.css";
import swal from "sweetalert";
import { useLocation, useNavigate, Link } from "react-router-dom";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import ToastError from "../../../../NotificationToast/ToastError";
import ToastSuccess from "../../../../NotificationToast/ToastSuccess";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ClipLoader, PulseLoader} from "react-spinners";
import { FiTrash2 } from "react-icons/fi";
import ModalInfo from "./modalInfo/info";
import * as XLSX from "xlsx";

/* ===========================
   🔥 SKELETON SHIMMER STYLE
=========================== */
const shimmerStyle = `
  @keyframes shimmer {
    0% { background-position: -468px 0; }
    100% { background-position: 468px 0; }
  }
  .shimmer {
    animation-duration: 1.2s;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
    animation-name: shimmer;
    background: #f6f7f8;
    background: linear-gradient(
      to right,
      #ddeaffff 8%,
      #f4f8ffff 18%,
      #ddeaffff 33%
    );
    background-size: 800px 104px;
  }
  .shimmer-select {
    height: 35px;
    border-radius: 4px;
  }
  .shimmer-row {
    height: 38px;
  }

  // .at-search{ min-width: 280px; }
  // .at-input{
  //   width:100%;
  //   height: 38px;
  //   border:1px solid #280095;
  //   border-radius: 10px;
  //   padding: 0 12px;
  //   font-size: 13px;
  //   outline:none;
  // }
  // .at-input:focus, .at-select:focus{
  //   border-color:#94a3b8;
  //   box-shadow: 0 0 0 3px rgba(148,163,184,0.25);
  // }

  /* ✅ ROW HOVER: input border ikut berwarna */
      .ysb-score-input{
        transition: border-color .12s ease, box-shadow .12s ease;
      }
      .ysb-row-hover:hover .ysb-score-input{
        border-color:#c0d2f1 !important;
      }
      .ysb-row-hover:hover .ysb-score-input:not(.ysb-input-disabled){
        box-shadow: 0 0 0 2px rgba(215, 226, 255, 0.18);
      }
      .ysb-row-hover:hover .ysb-score-input.ysb-input-disabled{
        border-color:#cbd5e1 !important;
        box-shadow:none;
      }

    /* ===== POPUP PILIH NILAI ===== */
    .ysb-score-popover{
      position: fixed;
      z-index: 9999;
      background: #fff;
      border: 1px solid #dbe6ff;
      border-radius: 10px;
      box-shadow: 0 8px 24px rgba(0,0,0,.12);
      padding: 8px;
      min-width: 170px;
    }
    .ysb-score-popover-grid{
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 6px;
    }
    .ysb-score-btn{
      border: 1px solid #cddcff;
      background: #f6f9ff;
      border-radius: 8px;
      height: 34px;
      font-weight: 700;
      cursor: pointer;
    }
    .ysb-score-btn:hover{
      background: #e8f0ff;
    }
    .ysb-score-btn:disabled{
      cursor: not-allowed;
      opacity: .5;
    }

    .ysb-score-btn-danger{
  border-color: #ffd5d5;
  background: #fff5f5;
}
.ysb-score-btn-danger:hover{
  background: #ffeaea;
}

.ysb-score-popover-grid-inline{
  display: grid;
  grid-template-columns: repeat(5, 1fr); /* 1 2 3 4 + trash */
  gap: 6px;
}

.ysb-score-btn-trash{
  border-color: #ffd5d5;
  background: #fff5f5;
  font-size: 16px;
  line-height: 1;
}
.ysb-score-btn-trash:hover{
  background: #ffeaea;
}




  `;



export default function Dimensi() {
  document.title = "Penilaian";

  // const [savingId, setSavingId] = useState(null);
  const [savingKey, setSavingKey] = useState(null);

  const [page] = useState(1);
  const [limit] = useState(1000);
  const [ascending] = useState(1);
  const [descending] = useState(0);
  const [keyword] = useState("");
  const token = localStorage.getItem("token");

  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 780px)" });
  const [loading, setLoading] = useState(false);
  const firstLoadDone = useRef(false);

  const storageBranchGroping = localStorage.getItem("ysb_branch_id");
  const storageLevel = localStorage.getItem("level");
  const storageSchoolId = localStorage.getItem('ysb_school_id');
  const storageTeacher = localStorage.getItem('teacherID');
  const storageBranch = localStorage.getItem('ysb_branch_id');

  // SEARCH
  const [searchMap, setSearchMap] = useState({});

  const [modalInfo, setModalInfo] = useState(false);

  // Data master
  const [getDataDimensi, setGetDataDimensi] = useState([]);
  const [loadingDimensi, setLoadingDimensi] = useState(true);
  const [getDataSemesterMap, setGetDataSemesterMap] = useState([]);

  // Table data
  const [getData, setGetData] = useState([]);

  // UI state
  const [hasSearched, setHasSearched] = useState(false);
  const [isFirstLoad, setIsFirstLoad] = useState(true);
  const [isFilterDirty, setIsFilterDirty] = useState(false);
  const [selectedTab, setSelectedTab] = useState(null);
  const [isFetching, setIsFetching] = useState(false);

  const [namaTA, setNamaTA] = useState("");
  const [namaSmstr, setNamaSmstr] = useState("");

  // Filter form
  const [form2, setForm2] = useState({
    ysb_semester_id: "",
    ysb_dimensi_id: "",
    ysb_branch_id: "",
    ysb_school_id: "",
    ysb_teacher_id: "",
  });

  const selectedSemester = useMemo(
    () =>
      getDataSemesterMap.find(
        (semester) => String(semester?.id) === String(form2?.ysb_semester_id)
      ) || null,
    [getDataSemesterMap, form2?.ysb_semester_id]
  );

  const isSelectedSemesterActive = Number(selectedSemester?.status) === 1;

  // EDIT nilai
  const [form3, setForm3] = useState({
    ysb_element_recap_id_id: "",
    ysb_sub_element_value: "",
  });

  const [updateId, setUpdateID] = useState(null);
  // const [scorePicker, setScorePicker] = useState({
  //   open: false,
  //   recapId: null,
  //   top: 0,
  //   left: 0,
  // });
  const [scorePicker, setScorePicker] = useState({
    open: false,
    recapId: null,
    top: 0,
    left: 0,
    meta: null,
  });
  const id_user = localStorage.getItem("id_admin") || "";
  const output_id_user = id_user.replace(/[|&;$%@"<>()+,]/g, "");

  // Permission
  const location = useLocation();
  const [permission, setPermission] = useState({
    create: 0,
    read: 0,
    update: 0,
    delete: 0,
  });
  const navigate = useNavigate();

  useEffect(() => {
    const level = localStorage.getItem("level");
    const storageItems = JSON.parse(localStorage.getItem("role_permission")) || [];
    if (level === "developer" || level === "superadmin") {
      setPermission({ create: 1, read: 1, update: 1, delete: 1 });
      return;
    }
    const foundPermission = storageItems.find((item) => item.menu?.url === location.pathname);
    if (!foundPermission) navigate("/dashboard");
    else {
      setPermission({
        create: foundPermission.create,
        read: foundPermission.read,
        update: foundPermission.update,
        delete: foundPermission.delete,
      });
    }
  }, [location.pathname, navigate]);

  /* API HEADERS */
  const fetchParams = useMemo(
    () => ({
      headers: {
        Authorization: `${token}`,
        "Content-Type": "application/json",
      },
    }),
    [token]
  );

  // ---------- helper refs ----------
  const isMounted = useRef(true);
  const abortControllers = useRef([]);

  useEffect(() => {
    return () => {
      isMounted.current = false;
      abortControllers.current.forEach((c) => c.abort());
    };
  }, []);

  const safeStr = (v) => (v === null || v === undefined ? "" : String(v));

  const getCellKey = (meta = {}) =>
  `${safeStr(meta?.ysb_student_id)}__${safeStr(meta?.ysb_sub_element_id)}`;


  const resolveCreatedRecapId = (response) => {
    return (
      response?.data?.data?.id ||
      response?.data?.data?.ysb_element_recap_id ||
      response?.data?.data?.ysb_element_recap_teacher_id ||
      response?.data?.data?.ysb_recap_id ||
      response?.data?.id ||
      response?.data?.ysb_element_recap_id ||
      response?.data?.ysb_element_recap_teacher_id ||
      null
    );
  };

  const updateLocalCellValue = (prevData, meta, value, newRecapId = null) => {
    const copy = JSON.parse(JSON.stringify(prevData || []));

    copy.forEach((group) => {
      (group?.data_element || []).forEach((el) => {
        (el?.rekapan || []).forEach((rekap) => {
          const sameStudent =
            safeStr(rekap?.ysb_student_id) === safeStr(meta?.ysb_student_id);

          let touched = false;

          (rekap?.sub_elements || []).forEach((sub) => {
            const sameSubElement =
              safeStr(sub?.ysb_sub_element_id) === safeStr(meta?.ysb_sub_element_id);

            if (sameStudent && sameSubElement) {
              sub.ysb_sub_element_value =
                value === "" || value === null || value === undefined
                  ? null
                  : Number(value);

              if (newRecapId) {
                sub.ysb_element_recap_id = newRecapId;
              }

              touched = true;
            }
          });

          if (touched) {
            rekap.average = calculateAverage(rekap?.sub_elements || []);
          }
        });
      });
    });

    return copy;
  };


  // =========================
  // INIT: Semester
  // =========================
  const fetchInit = useCallback(async () => {
    setLoading(true);
    const controller = new AbortController();
    abortControllers.current.push(controller);

    try {
      const semesterRes = await APIMS.get(
        `/api/access/semesters?page=${page}&limit=${limit}&ascending=${descending}&search=${keyword}`,
        { ...fetchParams, signal: controller.signal }
      );
      if (!isMounted.current) return;

      if (semesterRes?.status === 200) {
        const semesters = semesterRes.data.data || [];
        const active = semesters.find((s) => Number(s?.status) === 1) || semesters[0];
        setGetDataSemesterMap(semesters);
        if (active) {
          setNamaTA(active.name_year || "");
          setNamaSmstr(active.semester || "");
          setForm2((prev) => ({ ...prev, ysb_semester_id: active.id }));
        } else {
          setLoadingDimensi(false);
        }
      }
    } catch (err) {
      if (err?.name !== "CanceledError" && err?.name !== "AbortError") {
        swal({
          title: "Failed",
          text: err?.response?.data?.message || err.message || "Error",
          icon: "error",
        });
        setLoadingDimensi(false);
      }
    } finally {
      if (isMounted.current) setLoading(false);
    }
  }, [descending, fetchParams, keyword, limit, page]);

  useEffect(() => {
    fetchInit();
  }, [fetchInit]);

  // =========================
  // DIMENSI: mengikuti semester yang dipilih dan identitas guru
  // =========================
  useEffect(() => {
    if (!form2.ysb_semester_id) return;

    let cancelled = false;
    const controller = new AbortController();
    const fetchDimensi = async () => {
      setLoadingDimensi(true);
      setGetDataDimensi([]);
      setForm2((prev) => prev.ysb_dimensi_id === "" ? prev : { ...prev, ysb_dimensi_id: "" });

      const academicYearId =
        selectedSemester?.ysb_academic_year_id ??
        selectedSemester?.academic_year_id ??
        selectedSemester?.ysb_academic_year?.id ?? "";

      try {
        const response = await APILA.get("/api/access/dimensis", {
          ...fetchParams,
          signal: controller.signal,
          params: {
            page: 1,
            limit: 10,
            ascending: 1,
            search: "",
            branch: "",
            level: storageLevel || "",
            ysb_academic_year_id: academicYearId,
            ysb_semester_id: form2.ysb_semester_id,
            ysb_branch_id: storageBranch || "",
            ysb_school_id: storageSchoolId || "",
            ysb_grade_level_id: "",
            ysb_teacher_id: storageTeacher || "",
          },
        });
        if (cancelled || !isMounted.current) return;
        const dims = (Array.isArray(response?.data?.data) ? response.data.data : [])
          .filter((d) => d?.status === undefined || Number(d.status) === 1);
        setGetDataDimensi(dims);
        setForm2((prev) => ({ ...prev, ysb_dimensi_id: dims[0]?.id || "" }));
      } catch (error) {
        if (cancelled || !isMounted.current) return;
        console.error("Gagal mengambil data dimensi:", error);
        setGetDataDimensi([]);
        setForm2((prev) => ({ ...prev, ysb_dimensi_id: "" }));
      } finally {
        if (!cancelled && isMounted.current) setLoadingDimensi(false);
      }
    };

    fetchDimensi();
    return () => {
      cancelled = true;
      controller.abort();
    };
  }, [form2.ysb_semester_id, selectedSemester, fetchParams, storageLevel, storageBranch, storageSchoolId, storageTeacher]);

  // =========================
  // Filter complete
  // =========================
  const isFilterComplete =
    isFilterDirty &&
    !!form2.ysb_semester_id &&
    !!form2.ysb_dimensi_id;

  // =========================
  // Fetch table data
  // =========================
  const GetResponseData = useCallback(async () => {
  if (
    !form2.ysb_semester_id ||
    !form2.ysb_dimensi_id
  ) return;

  const params = {

     ysb_semester_id: form2?.ysb_semester_id,
          level: storageLevel,
          branch: storageBranch,
          ysb_dimensi_id: form2?.ysb_dimensi_id,
          ysb_school_id: storageSchoolId,
          ysb_teacher_id: storageTeacher
  };

  try {
    const response = await APILA.get(
      "/api/element-recaps-dimensi-teacher/full",
      {
        params,
        ...fetchParams,
      }
    );

    if (response?.status === 200) {
      setGetData(response.data.data || []);
    }
  } catch (error) {
    swal({
      title: "Gagal",
      text: error?.response?.data?.message || "Gagal mengambil data",
      icon: "error",
    });
  }
}, [form2, fetchParams, storageLevel]);



  // AUTO SELECT TAB
  useEffect(() => {
    if (getData.length > 0 && getData[0]?.data_element?.length > 0 && !selectedTab) {
      setSelectedTab(getData[0].data_element[0].name_element);
    }
  }, [getData, selectedTab]);

  // FIRST LOAD
  useEffect(() => {
    if (
      firstLoadDone.current ||
      !form2.ysb_semester_id ||
      !form2.ysb_dimensi_id
    ) return;
  
    firstLoadDone.current = true;
  
    (async () => {
      setIsFetching(true);
      await GetResponseData();
      setHasSearched(true);
      setIsFirstLoad(false);
      setIsFilterDirty(false);
      setIsFetching(false);
    })();
  
  }, [
    form2.ysb_semester_id,
    form2.ysb_dimensi_id
  ]);

  // Reset tab 
  useEffect(() => {
    setSelectedTab(null);
  }, [
    form2.ysb_semester_id,
    form2.ysb_dimensi_id
  ]);

  // =========================
  // HANDLER perubahan filter 
  // =========================
  const handleChange = (e) => {
    const { name, value } = e.target;

    setForm2((prev) => ({ ...prev, [name]: value }));

    if (!isFirstLoad) {
      setIsFilterDirty(true);
      setHasSearched(false);
    }
  };


  // =========================
  // BUTTON CARI
  // =========================
  const handleCari = async () => {
    if (!form2.ysb_semester_id ||  !form2.ysb_dimensi_id ) {
      swal({
        title: "Filter belum lengkap",
        text: "Pastikan Semester dan Dimensi sudah dipilih.",
        icon: "warning",
      });
      return;
    }

    setSelectedTab(null);
    setGetData([]);
    setHasSearched(false);
    setIsFetching(true);

    try {
      await GetResponseData();
      setHasSearched(true);
      setIsFilterDirty(false);
    } catch (err) {
      swal({
        title: "Failed",
        text: err?.response?.data?.message || "Terjadi kesalahan",
        icon: "error",
      });
    } finally {
      setIsFetching(false);
    }
  };

  // =========================
  // INPUT NILAI (1-4) TANPA DESIMAL
  // =========================
  const handleForm3Change = (e) => {
    const { name, value } = e.target;

    // Izinkan kosong (untuk hapus nilai)
    if (value === "") {
      setForm3((prev) => ({ ...prev, [name]: "" }));
      return;
    }

    // Hanya izinkan 1 digit (1-4) tidak boleh pecahan decimal
    if (/^[1-4]$/.test(value)) {
      setForm3((prev) => ({ ...prev, [name]: value }));
    }
  };


  // =========================
  // SAVE NILAI
  // =========================
  const originalValueRef = useRef(null);
  const popoverRef = useRef(null);


  const openScorePicker = (
    event,
    recapId,
    currentValue,
    isLogLocked,
    meta = {}
  ) => {
    if (!permission.update || isLogLocked || !isSelectedSemesterActive) return;

    const rect = event.currentTarget.getBoundingClientRect();
    const pickerWidth = 190;
    const pickerHeight = 56;

    let top = rect.top - pickerHeight - 8;
    let left = rect.left + rect.width / 2 - pickerWidth / 2;

    if (top < 8) top = rect.bottom + 8;
    if (left < 8) left = 8;
    if (left + pickerWidth > window.innerWidth - 8) {
      left = window.innerWidth - pickerWidth - 8;
    }

    originalValueRef.current = currentValue == null ? "" : String(currentValue);

    setUpdateID(recapId);
    setForm3({
      ysb_element_recap_id_id: recapId,
      ysb_sub_element_value: currentValue == null ? "" : String(currentValue),
    });

    setScorePicker({
      open: true,
      recapId,
      top,
      left,
      meta,
    });
  };


  useEffect(() => {
    if (!scorePicker.open) return;

    const close = () =>
      // setScorePicker({ open: false, recapId: null, top: 0, left: 0 });
      setScorePicker({ open: false, recapId: null, top: 0, left: 0, meta: null });

    const onKeyDown = (e) => {
      if (e.key === "Escape") close();
    };

    const onDocMouseDown = (e) => {
      const target = e.target;

      // klik di dalam popup -> jangan tutup
      if (popoverRef.current && popoverRef.current.contains(target)) return;

      // klik di input form nilai -> biarkan flow openScorePicker bekerja
      if (target.closest?.(".ysb-score-input")) return;

      // selain itu, tutup popup
      close();
    };

    document.addEventListener("keydown", onKeyDown);
    document.addEventListener("mousedown", onDocMouseDown);
    window.addEventListener("scroll", close, true);
    window.addEventListener("resize", close);

    return () => {
      document.removeEventListener("keydown", onKeyDown);
      document.removeEventListener("mousedown", onDocMouseDown);
      window.removeEventListener("scroll", close, true);
      window.removeEventListener("resize", close);
    };
  }, [scorePicker.open]);

const saveForm3 = async (payload) => {
  const incomingRecapId = payload?.recapId ?? form3?.ysb_element_recap_id_id;
  const meta = payload?.meta ?? scorePicker?.meta ?? {};
  const newValue = payload?.newValue ?? (form3?.ysb_sub_element_value ?? "");
  const oldValue = payload?.oldValue ?? (originalValueRef.current ?? "");

  if (!isSelectedSemesterActive) {
    ToastError.fire({
      icon: "warning",
      title: "Semester tidak aktif. Nilai hanya dapat diinput pada semester aktif.",
    });
    setUpdateID(null);
    return;
  }

  if (!meta?.ysb_student_id || !meta?.ysb_sub_element_id) return;

  if (String(newValue) === String(oldValue)) {
    setUpdateID(null);
    return;
  }

  const saveKey = getCellKey(meta);
  setSavingKey(saveKey);

  const previousData = JSON.parse(JSON.stringify(getData || []));

  // cari recap id TERBARU dari state, jangan hanya percaya dari payload lama
  const latestCell =
    getData?.[0]?.data_element
      ?.flatMap((el) => el?.rekapan || [])
      ?.find((rekap) => safeStr(rekap?.ysb_student_id) === safeStr(meta?.ysb_student_id))
      ?.sub_elements
      ?.find((sub) => safeStr(sub?.ysb_sub_element_id) === safeStr(meta?.ysb_sub_element_id));

  const latestRecapId =
    latestCell?.ysb_element_recap_id || incomingRecapId || "default";

  const isDefaultId =
    !latestRecapId || safeStr(latestRecapId).toLowerCase() === "default";

  // optimistic update
  setGetData((prev) => updateLocalCellValue(prev, meta, newValue));

  try {
    const endpoint = isDefaultId
      ? `/api/element-recaps-dimensi-teacher/default`
      : `/api/element-recaps-dimensi-teacher/${latestRecapId}`;

    // payload create & update dibuat SAMA-SAMA lengkap
    const requestBody = {
      ysb_semester_id: meta?.ysb_semester_id || form2?.ysb_semester_id,
      ysb_school_id: meta?.ysb_school_id || storageSchoolId,
      ysb_teacher_id: meta?.ysb_teacher_id || storageTeacher,
      ysb_student_id: meta?.ysb_student_id,
      ysb_element_id: meta?.ysb_element_id,
      ysb_sub_element_id: meta?.ysb_sub_element_id,
      ysb_sub_element_value: newValue === "" ? null : Number(newValue),
      user_id: output_id_user,
    };

    const response = await APILA.put(endpoint, requestBody, fetchParams);

    if (response?.status === 200) {
      let finalRecapId = latestRecapId;

      if (isDefaultId) {
        const createdRecapId = resolveCreatedRecapId(response);

        if (createdRecapId) {
          finalRecapId = createdRecapId;

          setGetData((prev) =>
            updateLocalCellValue(prev, meta, newValue, createdRecapId)
          );

          setForm3((prev) => ({
            ...prev,
            ysb_element_recap_id_id: createdRecapId,
          }));
        }
      }

      setScorePicker((prev) => ({
        ...prev,
        recapId: finalRecapId,
        meta: {
          ...(prev?.meta || {}),
          ...meta,
          ysb_element_recap_id: finalRecapId,
        },
      }));

      setUpdateID(finalRecapId);

      ToastSuccess.fire({
        icon: "success",
        title: "Nilai berhasil disimpan",
      });
    }
  } catch (error) {
    setGetData(previousData);

    ToastError.fire({
      icon: "error",
      title:
        error?.response?.data?.message ||
        error.message ||
        "Gagal menyimpan nilai",
    });
  } finally {
    setSavingKey(null);
  }
};


  const pickScore = async (value) => {
  const recapId = scorePicker.recapId;
  const meta = scorePicker.meta;
  if (!meta) return;

  const newValue = String(value);
  const oldValue = originalValueRef.current ?? "";

  setForm3({
    ysb_element_recap_id_id: recapId,
    ysb_sub_element_value: newValue,
  });

  if (String(newValue) === String(oldValue)) {
    setScorePicker({ open: false, recapId: null, top: 0, left: 0, meta: null });
    setUpdateID(null);
    return;
  }

  await saveForm3({ recapId, meta, newValue, oldValue });

  setScorePicker({ open: false, recapId: null, top: 0, left: 0, meta: null });
};


  const clearScore = async () => {
  const recapId = scorePicker.recapId;
  const meta = scorePicker.meta;
  if (!meta) return;

  const newValue = "";
  const oldValue = originalValueRef.current ?? "";

  setForm3({
    ysb_element_recap_id_id: recapId,
    ysb_sub_element_value: newValue,
  });

  if (String(oldValue) === "") {
    setScorePicker({ open: false, recapId: null, top: 0, left: 0, meta: null });
    setUpdateID(null);
    return;
  }

  await saveForm3({ recapId, meta, newValue, oldValue });

  setScorePicker({ open: false, recapId: null, top: 0, left: 0, meta: null });
};



  // =========================
  // RATA-RATA
  // =========================
  const calculateAverage = (subElements) => {
    const values = subElements
      .map((s) => s.ysb_sub_element_value)
      .filter(
        (v) =>
          v !== null &&
          v !== "" &&
          v !== undefined &&
          !isNaN(Number(v))
      )
      .map(Number);

    if (values.length === 0) return 0;

    const total = values.reduce((a, b) => a + b, 0);
    // return Math.round((total / values.length) * 10) / 10;
    return Number((total / values.length ?? 0).toFixed(2));
  };

  // SEARCH 
  useEffect(() => {
    setSearchMap({});
  }, [form2.ysb_semester_id, form2.ysb_dimensi_id]);


  const toTitleCase = (value) => {
    const s = safeStr(value).toLowerCase().trim();
    if (!s) return "";
    return s.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.slice(1));
  };

  // Fungsi Export & Import
  const [isExporting, setIsExporting] = useState(false);
  const [isImporting, setIsImporting] = useState(false);

  const handleExport = async () => {
    if (!form2.ysb_semester_id) {
      swal({
        title: "Filter belum lengkap",
        text: "Pilih Semester terlebih dahulu.",
        icon: "warning",
      });
      return;
    }

    setIsExporting(true);

    try {
      const params = {
        ysb_semester_id: form2.ysb_semester_id,
        ysb_school_id: storageSchoolId,
        ysb_teacher_id: storageTeacher,
      };

      const response = await APILA.get("/api/element-recaps-dimensi-teacher/full", {
        params,
        ...fetchParams,
      });

      const dataExport = response?.data?.data || [];

      if (dataExport.length === 0) {
        swal({ title: "Data Kosong", text: "Tidak ada data untuk diekspor.", icon: "info" });
        return;
      }

      const wb = XLSX.utils.book_new();

      dataExport.forEach((dimensi) => {
        const sheetData = [];
        let rowIndex = 0;

        const mainHeader = ["No", "Nama Siswa", "NISN"];
        const subHeader = ["", "", ""];

        dimensi.data_element.forEach((element) => {
          const subElements = element.rekapan?.[0]?.sub_elements || [];
          const subCount = subElements.length;

          if (subCount > 0) {
            mainHeader.push(element.description || element.name_element || "Element");
            
            subElements.forEach(sub => {
              subHeader.push(sub.ysb_sub_element_name || sub.description || "");
            });

            for (let i = 1; i < subCount; i++) {
              mainHeader.push("");
            }
          }
        });

        sheetData[rowIndex++] = mainHeader;
        sheetData[rowIndex++] = subHeader;

        const allStudents = dimensi.data_element[0]?.rekapan 
          ? [...dimensi.data_element[0].rekapan] 
          : [];

        allStudents.sort((a, b) => {
          const nameA = (a.name_student || "").toLowerCase().trim();
          const nameB = (b.name_student || "").toLowerCase().trim();
          return nameA.localeCompare(nameB, 'id', { sensitivity: 'base' });
        });

        allStudents.forEach((rekap, idx) => {
          const row = [
            idx + 1,
            rekap.name_student || "",
            rekap.nisn || "",
          ];

          dimensi.data_element.forEach((element) => {
            const studentData = element.rekapan?.find(r => 
              String(r.ysb_student_id) === String(rekap.ysb_student_id)
            );

            if (studentData && studentData.sub_elements) {
              studentData.sub_elements.forEach(sub => {
                const value = sub.ysb_sub_element_value;
                row.push(value !== null && value !== undefined ? value : "");
              });
            } else {
              const subLen = element.rekapan?.[0]?.sub_elements?.length || 0;
              for (let i = 0; i < subLen; i++) {
                row.push("");
              }
            }
          });

          sheetData[rowIndex++] = row;
        });

        const ws = XLSX.utils.aoa_to_sheet(sheetData);

        ws['!merges'] = [];
        ws['!merges'].push({ s: { r: 0, c: 0 }, e: { r: 1, c: 0 } }); 
        ws['!merges'].push({ s: { r: 0, c: 1 }, e: { r: 1, c: 1 } }); 
        ws['!merges'].push({ s: { r: 0, c: 2 }, e: { r: 1, c: 2 } }); 

        let currentCol = 3;
        dimensi.data_element.forEach((element) => {
          const subCount = element.rekapan?.[0]?.sub_elements?.length || 0;
          if (subCount > 1) {
            ws['!merges'].push({
              s: { r: 0, c: currentCol },
              e: { r: 0, c: currentCol + subCount - 1 }
            });
          }
          currentCol += subCount;
        });

        ws['!cols'] = [
          { wch: 5 }, 
          { wch: 35 }, 
          { wch: 15 },
          ...Array(currentCol - 3).fill({ wch: 14 })
        ];

        XLSX.utils.book_append_sheet(wb, ws, dimensi.name_dimensi.substring(0, 31));
      });

      const fileName = `Laporan_Penilaian_${namaTA}_Smt${namaSmstr}_${new Date().toISOString().slice(0,10)}.xlsx`;
      XLSX.writeFile(wb, fileName);

      ToastSuccess.fire({ icon: "success", title: "Export Excel berhasil!" });

    } catch (error) {
      console.error(error);
      swal({
        title: "Gagal Export",
        text: error?.response?.data?.message || "Terjadi kesalahan saat mengexport",
        icon: "error",
      });
    } finally {
      setIsExporting(false);
    }
  };

  const handleImport = async (e) => {
    if (!isSelectedSemesterActive) {
      swal({
        title: "Semester tidak aktif",
        text: "Import nilai hanya dapat dilakukan pada semester yang aktif.",
        icon: "warning",
      });
      e.target.value = "";
      return;
    }

    const file = e.target.files[0];
    
    if (!file) return;

    if (!file.name.match(/\.(xlsx|xls)$/)) {
      swal({ title: "Format Salah", text: "Hanya file .xlsx atau .xls yang diizinkan", icon: "error" });
      return;
    }

    setIsImporting(true);

    try {
      const arrayBuffer = await file.arrayBuffer();
      const workbook = XLSX.read(arrayBuffer, { type: 'array' });

      const result = [];

      for (const sheetName of workbook.SheetNames) {
        const worksheet = workbook.Sheets[sheetName];
        const data = XLSX.utils.sheet_to_json(worksheet, { header: 1, defval: "" });

        if (data.length < 3) continue;

        const dimensiName = sheetName.trim();
        const elements = [];

        const elementRow = data[0];   
        const indicatorRow = data[1]; 

        let currentElement = null;
        let indikators = [];

        for (let col = 2; col < Math.max(elementRow.length, indicatorRow.length); col++) {  
          const elementName = String(elementRow[col] || "").trim();
          const indicatorName = String(indicatorRow[col] || "").trim();

          if (elementName && elementName !== currentElement) {
            if (currentElement && indikators.length > 0) {
              elements.push({
                name_element: currentElement,
                indikators: [...indikators]
              });
            }
            currentElement = elementName;
            indikators = [];
          }

          if (indicatorName && currentElement) {
            indikators.push({
              name_indikator: indicatorName,
              students: []
            });
          }
        }

        if (currentElement && indikators.length > 0) {
          elements.push({
            name_element: currentElement,
            indikators: indikators
          });
        }

        for (let rowIdx = 2; rowIdx < data.length; rowIdx++) {
          const row = data[rowIdx];
          if (!row || row.length < 3) continue;

          const name_student = String(row[1] || "").trim();  
          const nisn = String(row[2] || "").trim();          

          if (!name_student) continue;

          let colIndex = 3;

          elements.forEach(element => {
            element.indikators.forEach(indikator => {
              const value = String(row[colIndex] || "").trim();
              indikator.students.push({
                name_student,
                nisn,
                value: value || ""
              });
              colIndex++;
            });
          });
        }

        result.push({
          name_dimensi: dimensiName,
          elements: elements
        });
      }

      const payload = {
        ysb_semester_id: form2.ysb_semester_id || "",
        ysb_branch_id: storageBranch || "",
        ysb_school_id: storageSchoolId || "",
        ysb_grade_level_id: "",           
        ysb_kelas_id: "",                 
        ysb_teacher_id: storageTeacher || "",
        data: result
      };

      const response = await APILA.post(
        "/api/element-recaps-dimensi-teacher/import", 
        payload, 
        fetchParams
      );

      if (response?.status === 200) {
        swal({
          title: "Berhasil",
          text: "Import data berhasil diproses",
          icon: "success",
        });
        await GetResponseData(); 
      }

    } catch (error) {
      console.error("Error parsing Excel:", error);
      swal({
        title: "Gagal Membaca File",
        text: error.message,
        icon: "error",
      });
    } finally {
      setIsImporting(false);
      e.target.value = '';
    }
  };

  return (
    <>
      <style>{shimmerStyle}</style>

      <div className="body module-page assessment-page">

      {modalInfo && (
        <ModalInfo
          show={modalInfo}
          onHide={() => setModalInfo(false)}
        />
      )}

       
      <div className="page-header-card">
         {isTabletOrMobile ? (
          <>
            <div className="page-header-top d-flex">
              <div className="page-title-wrap">
                <span className="page-title-icon">
                  <FontAwesomeIcon icon={faIdCard} />
                  </span>
                <h4 className="page-title-text"> Penilaian</h4>
              </div>
            </div>

            <Row style={{ marginTop: "10px", padding: "0 12px"}}>
              <button
                 className="btn btn-create module-header-button mr-2"
                 onClick={() => setModalInfo(true)}
                  style={{
                      borderRadius: 12,
                      padding: "8px 14px",
                      boxShadow: "0 10px 24px rgba(108,99,255,0.18)",
                  }}
                >
                   Keterangan Range Nilai
              </button>
            </Row>

 
             <nav aria-label="breadcrumb" className="custom-breadcrumb-nav mt-4">
              <ol className="custom-breadcrumb">
                <li className="custom-breadcrumb-item">
                  <Link to="/dashboards-teacher">Dashboard</Link>
                </li>
                <li className="custom-breadcrumb-separator">/</li>
                <li
                  className="custom-breadcrumb-item active"
                  aria-current="page"
                >
                  Penilaian
                </li>
              </ol>
            </nav>
          </>
          ) : (
          <>
            <div className="page-header-top d-flex">
              <div className="page-title-wrap">
                <span className="page-title-icon">
                  <FontAwesomeIcon icon={faIdCard} />
                </span>
                <h4 className="page-title-text"> Penilaian</h4>
              </div>

              <div className="assessment-toolbar-actions ml-auto">
                <button
                  onClick={() => setModalInfo(true)}
                  className="btn btn-create module-header-button mr-2"
                  style={{
                      borderRadius: 12,
                      padding: "8px 14px",
                      boxShadow: "0 10px 24px rgba(108,99,255,0.18)",
                      backgroundColor: "#f28500"
                  }}
                >
                  Keterangan Range Nilai
                </button>
              </div>

            </div>

            <nav aria-label="breadcrumb" className="custom-breadcrumb-nav mt-4">
              <ol className="custom-breadcrumb">
                <li className="custom-breadcrumb-item">
                  <Link to="/dashboards-teacher">Dashboard</Link>
                </li>
                <li className="custom-breadcrumb-separator">/</li>
                <li
                  className="custom-breadcrumb-item active"
                  aria-current="page"
                >
                  Penilaian
                </li>
              </ol>
            </nav>
          </>
         )}
      </div>


        <div className="body-content module-content mt-2">
    
          {/* FILTER */}
          {isTabletOrMobile ? (
            <div className="assessment-filter-card assessment-filter-mobile">
              <Row style={{ marginTop: "10px", padding: "0 12px" }}>
                <select
                  className="assessment-filter-select mr-2"
                  name="ysb_semester_id"
                  value={form2.ysb_semester_id}
                  onChange={handleChange}
                  style={{
                    border: "1px solid #d9defa",
                    borderRadius: "12px",
                    fontSize: "14px",
                    padding: "10px 12px",
                    background: "#fff",
                  }}
                >
                  <option value="" hidden>
                    {namaTA} (Semester {namaSmstr})
                  </option>
                  {getDataSemesterMap.map((user, index) => (
                    <option key={index} value={user?.id}>
                      {user?.name_year} (Semester {user?.semester}){Number(user?.status) === 1 ? " • Aktif" : ""}
                    </option>
                  ))}
                </select>
              </Row>

              <Row style={{ marginTop: "10px", padding: "0 12px" }}>
                <select
                  className="assessment-filter-select mr-2"
                  name="ysb_dimensi_id"
                  value={form2.ysb_dimensi_id}
                  onChange={handleChange}
                  disabled={loadingDimensi}
                  style={{
                    border: "1px solid #d9defa",
                    borderRadius: "12px",
                    fontSize: "14px",
                    padding: "10px 12px",
                    background: "#fff",
                  }}
                >
                  <option value="" hidden>
                    {loadingDimensi ? "Memuat dimensi..." : getDataDimensi.length === 0 ? "Belum ada dimensi" : "Pilih Dimensi"}
                  </option>
                  {getDataDimensi.map((user, index) => (
                    <option key={index} value={user?.id}>
                      {user?.name_dimensi}
                    </option>
                  ))}
                </select>
              </Row>

              <Row style={{ marginTop: "12px", padding: "0 12px" }}>
                <button
                  onClick={handleCari}
                  disabled={!isFilterComplete}
                  className="btn assessment-filter-button"
                  style={{
                    fontSize: "13px",
                    padding: "10px 16px",
                    borderRadius: "12px",
                    backgroundColor: !isFilterComplete ? "#c9c9c9" : "#eca91aff",
                    color: "#fff",
                    cursor: !isFilterComplete ? "not-allowed" : "pointer",
                  }}
                >
                  Cari
                </button>
              </Row>
            </div>
          ) : (
            <>
            <div className="assessment-filter-card mb-3">
                {loading ? (
                  <>
                    <div className="mb-3 d-flex">
                      <div className="shimmer shimmer-select mr-3" style={{width:250, borderRadius: "12px"}} />
                      <div className="shimmer shimmer-select mr-3" style={{width:250, borderRadius: "12px"}} />
                      <div className="shimmer shimmer-select mr-3" style={{width:70, borderRadius: "12px"}} />
                    </div>
                    
                  </>
                ) : (
                  <div className="mb-3 mt-2">
                    <div className="assessment-filter-row d-flex">
                      <select
                        className="assessment-filter-select mr-2"
                        name="ysb_semester_id"
                        value={form2.ysb_semester_id}
                        onChange={handleChange}
                        style={{
                              border: "1px solid #d9defa",
                              borderRadius: "12px",
                              fontSize: "14px",
                              padding: "10px 12px",
                              background: "#fff",
                            }}
                      >
                        <option value="" hidden>
                          {namaTA} (Semester {namaSmstr})
                        </option>
                        {getDataSemesterMap.map((user, index) => (
                          <option key={index} value={user?.id}>
                            {user?.name_year} (Semester {user?.semester}){Number(user?.status) === 1 ? " • Aktif" : ""}
                          </option>
                        ))}
                      </select>

                      <select
                        className="assessment-filter-select mr-2"
                        name="ysb_dimensi_id"
                        value={form2.ysb_dimensi_id}
                        onChange={handleChange}
                        disabled={loadingDimensi}
                        style={{
                              border: "1px solid #d9defa",
                              borderRadius: "12px",
                              fontSize: "14px",
                              padding: "10px 12px",
                              background: "#fff",
                            }}
                      >
                        <option value="" hidden>
                          {loadingDimensi ? "Memuat dimensi..." : getDataDimensi.length === 0 ? "Belum ada dimensi" : "Pilih Dimensi"}
                        </option>
                        {getDataDimensi.map((user, index) => (
                          <option key={index} value={user?.id}>
                            {user?.name_dimensi}
                          </option>
                        ))}
                      </select>

                      <button
                        onClick={handleCari}
                        disabled={!isFilterComplete}
                        className="btn assessment-filter-button"
                        style={{
                          fontSize: "13px",
                          padding: "10px 16px",
                            borderRadius: "12px",
                          backgroundColor: !isFilterComplete ? "#c9c9c9" : "#eca91aff",
                          color: "#fff",
                          cursor: !isFilterComplete ? "not-allowed" : "pointer",
                        }}
                      >
                        Cari
                      </button>

<div className="assessment-toolbar-actions ml-auto">

  <button
                        onClick={() => document.getElementById('importFile').click()}
                        disabled={isExporting || isImporting || !isSelectedSemesterActive}
                        className="btn assessment-toolbar-button assessment-import-button"
                        style={{
                          fontSize: "13px",
                          padding: "10px 16px",
                          borderRadius: "12px",
                          backgroundColor: isImporting ? "#9ca3af" : "#007bff",
                          color: "#fff",
                          cursor: isImporting ? "not-allowed" : "pointer",
                          marginRight: "8px"
                        }}
                      >
                        {isImporting ? "Importing..." : "Import Excel"}
                      </button>

 <button
                        onClick={handleExport}
                        disabled={isExporting || isImporting}
                        className="btn assessment-toolbar-button assessment-export-button"
                        style={{
                          fontSize: "13px",
                          padding: "10px 16px",
                          borderRadius: "12px",
                          backgroundColor: isExporting ? "#9ca3af" : "#23ae00",
                          color: "#fff",
                          cursor: isExporting ? "not-allowed" : "pointer",
                        }}
                      >
                        {isExporting ? "Exporting..." : "Export Excel"}
                      </button>

                      
</div>
                     

                      <input
                        type="file"
                        id="importFile"
                        accept=".xlsx,.xls"
                        style={{ display: "none" }}
                        onChange={handleImport}
                      />
                    </div>
                  </div>
                )}
              </div>
            </>
            
          )}

          {form2.ysb_semester_id && !isSelectedSemesterActive && (
            <div className="assessment-status-banner" role="status">
              <span className="assessment-status-dot" />
              <div>
                <strong>Semester tidak aktif.</strong> Data nilai tetap dapat dilihat, tetapi input dan import nilai dinonaktifkan. Penilaian hanya bisa diinput pada semester yang berstatus aktif.
              </div>
            </div>
          )}

          {/* LOADER */}
          {isFetching && (
            <div className="text-center" style={{ padding: "10px 0" }}>
              <span style={{color: "#2e52aeff", fontWeight: "500"}}><PulseLoader color={'#3f5bea'} size={12}/></span>
            </div>
          )}

          {/* TABLE */}
          {hasSearched && !isFetching && (
            <Tabs id="uncontrolled-tab-example" activeKey={selectedTab} onSelect={(k) => setSelectedTab(k)} className="assessment-tabs mb-3 mt-4 nav-tabs">
              {(getData?.[0]?.data_element || []).map((element, eIdx) => (
                <Tab key={element?.id || eIdx} eventKey={element?.name_element} title={element?.name_element} className="nav-item">
                  <div className="assessment-element-info text-center">
                    <h5 className="mt-2 mb-2">{element?.description}</h5>
                  </div>

                  <div className="mt-3">
                    <div className="module-search-wrap assessment-search-wrap">
                      <input
                        className="module-search-input assessment-search-input"
                        placeholder="Cari Siswa / NISN"
                        value={searchMap[element?.id] || ""}
                        onChange={(e) =>
                          setSearchMap((prev) => ({
                            ...prev,
                            [element?.id]: e.target.value,
                          }))
                        }
                      />
                    </div>
                  </div>


                  <Col xl="12" sm="12">
                    <div className="mt-3">
                      <div className="module-table-card assessment-table-card">
                        <div className="module-table-scroll assessment-table-scroll">
                          <table className="module-table assessment-table" id="basic-datatable">
                            <thead>
                              <tr>
                                <th style={{ textAlign: "center", border: "1px solid #e0e0e0ff" }}>No</th>
                                <th style={{ textAlign: "center", border: "1px solid #e0e0e0ff" }}>Nama</th>
                                <th style={{ textAlign: "center", border: "1px solid #e0e0e0ff" }}>Nisn</th>
                  
                                {element?.rekapan?.[0]?.sub_elements?.map((sub, idx) => (
                                  <th style={{ textAlign: "center", border: "1px solid #e0e0e0ff" }} key={sub?.ysb_sub_element_id || idx}>
                                    {sub?.ysb_sub_element_name || sub?.description}
                                  </th>
                                ))}
                                
                                <th style={{ textAlign: "center", border: "1px solid #e0e0e0ff" }}>Rata-Rata</th>
                              </tr>
                            </thead>
                  
                           <tbody>
                            {(() => {
                              const q = String(searchMap[element?.id] || "").trim().toLowerCase();

                              // const rows = [...(element?.rekapan || [])].sort((a, b) =>
                              //   String(a?.name_student || "").localeCompare(
                              //     String(b?.name_student || ""),
                              //     "id",
                              //     { sensitivity: "base" }
                              //   )
                              // );

                              const rows = [...(element?.rekapan || [])].sort((a, b) => {
                                const orderA =
                                  a?.order_absen === null ||
                                  a?.order_absen === undefined ||
                                  a?.order_absen === ""
                                    ? null
                                    : Number(a.order_absen);

                                const orderB =
                                  b?.order_absen === null ||
                                  b?.order_absen === undefined ||
                                  b?.order_absen === ""
                                    ? null
                                    : Number(b.order_absen);

                                const aIsNew = orderA !== null && !Number.isNaN(orderA);
                                const bIsNew = orderB !== null && !Number.isNaN(orderB);

                                // siswa lama tetap di atas
                                if (!aIsNew && bIsNew) return -1;

                                // siswa baru taruh di bawah
                                if (aIsNew && !bIsNew) return 1;

                                // sama-sama siswa baru => urut berdasarkan order_absen
                                if (aIsNew && bIsNew) {
                                  if (orderA !== orderB) return orderA - orderB;

                                  const nameCompare = String(a?.name_student || "").localeCompare(
                                    String(b?.name_student || ""),
                                    "id",
                                    { sensitivity: "base", numeric: true }
                                  );

                                  if (nameCompare !== 0) return nameCompare;

                                  return String(a?.nisn || "").localeCompare(
                                    String(b?.nisn || ""),
                                    "id",
                                    { sensitivity: "base", numeric: true }
                                  );
                                }

                                // sama-sama siswa lama => tetap A-Z
                                const nameCompare = String(a?.name_student || "").localeCompare(
                                  String(b?.name_student || ""),
                                  "id",
                                  { sensitivity: "base", numeric: true }
                                );

                                if (nameCompare !== 0) return nameCompare;

                                return String(a?.nisn || "").localeCompare(
                                  String(b?.nisn || ""),
                                  "id",
                                  { sensitivity: "base", numeric: true }
                                );
                              });

                              const filteredRows = !q
                                ? rows
                                : rows.filter((r) => {
                                    const name = String(r?.name_student || "").toLowerCase();
                                    const nisn = String(r?.nisn || "").toLowerCase();
                                    return name.includes(q) || nisn.includes(q);
                                  });

                              const subLen = element?.rekapan?.[0]?.sub_elements?.length || 0;
                              const colSpan = 4 + subLen; 

                              if (filteredRows.length === 0) {
                                return (
                                  <tr>
                                    <td colSpan={colSpan} className="module-empty-state assessment-empty-state">
                                      Data tidak ditemukan
                                    </td>
                                  </tr>
                                );
                              }

                              return filteredRows.map((rekap, rowIdx) => (
                                <tr key={rekap?.ysb_element_recap_id} className="ysb-row-hover">
                                  <td className="text-center"><span className="assessment-number-badge">{rowIdx + 1}</span></td>
                                  <td style={{ lineHeight: "2" }}>{toTitleCase(rekap?.name_student)}</td>
                                  <td style={{ lineHeight: "2", textAlign: "center" }}>{rekap?.nisn}</td>

                                  {rekap?.sub_elements?.map((sub, i) => {
                                   
                                    const subRecapIdVal = sub?.ysb_element_recap_id;
                                    const subValueLocal = sub?.ysb_sub_element_value;
                                    const isEditingLocal = updateId === subRecapIdVal;

                                    const isLogLocked = String(sub?.ysb_log_value_status) === "0";
                                      const isScoreDisabled = isLogLocked || !isSelectedSemesterActive || !permission.update;

                                    const cellMeta = {
                                      ysb_element_recap_id: subRecapIdVal,
                                      ysb_semester_id: form2?.ysb_semester_id,
                                      ysb_school_id: storageSchoolId,
                                      ysb_teacher_id: storageTeacher,
                                      ysb_student_id: rekap?.ysb_student_id,
                                      ysb_element_id: sub?.ysb_element_id || element?.id,
                                      ysb_sub_element_id: sub?.ysb_sub_element_id,
                                    };

                                    const cellKey = getCellKey(cellMeta);

                                    const handleClickCell = (e) => {
                                      openScorePicker(
                                        e,
                                        subRecapIdVal,
                                        subValueLocal,
                                        isLogLocked,
                                        cellMeta
                                      );
                                    };


                                    return (
                                      <td key={subRecapIdVal || i} style={{ lineHeight: "2" }} className="text-center">
                                        {/* {savingId === subRecapIdVal ? ( */}
                                        {savingKey === cellKey ? (
                                          <div className="d-flex justify-content-center mt-2">
                                            <ClipLoader size={14} color="#3f5bea" />
                                          </div>
                                        ) : (
                                          <input
                                            type="text"
                                            onClick={(e) => handleClickCell(e)}
                                            value={subValueLocal == null ? "" : subValueLocal}
                                            disabled={isScoreDisabled}
                                            title={!isSelectedSemesterActive ? "Semester tidak aktif - hanya dapat melihat nilai" : isLogLocked ? "Nilai terkunci" : !permission.update ? "Tidak memiliki akses untuk mengubah nilai" : "Klik untuk input nilai"}
                                            className={`ysb-score-input text-center ${isScoreDisabled ? "ysb-input-disabled" : ""}`}
                                            style={{
                                              border: "1px solid #e7eefa",
                                              borderRadius: "5px",
                                              width: "40px",
                                              backgroundColor: isScoreDisabled ? "#f3f5f8" : "#fff",
                                              cursor: isScoreDisabled ? "not-allowed" : "pointer",
                                            }}
                                            readOnly
                                          />
                                        )

                                        }
                                      </td>
                                    );
                                  })}

                                  <td style={{ lineHeight: "2" }} className="text-center fw-bold">
                                    {(() => {
                                      const v = Number((rekap?.average ?? 0).toFixed(2));
                                      return v % 1 === 0 ? v.toFixed(0) : v.toString();
                                    })()}
                                  </td>
                                </tr>
                              ));
                            })()}
                          </tbody>

                        </table>
                      </div>
                    </div>
                  </div>

                  
                </Col>
                </Tab>
              ))}
            </Tabs>
          )}
        </div>
      </div>

        {scorePicker.open && (
        <div
          className="ysb-score-popover"
          style={{ top: scorePicker.top, left: scorePicker.left }}
          onMouseDown={(e) => e.stopPropagation()}
        >
          <div className="ysb-score-popover-grid ysb-score-popover-grid-inline">
            {[1, 2, 3, 4].map((n) => (
              <button
                key={n}
                type="button"
                className="ysb-score-btn"
                onMouseDown={(e) => {
                  e.preventDefault();
                  pickScore(n);
                }}
              >
                {n}
              </button>
            ))}


            <button
              type="button"
              className="ysb-score-btn ysb-score-btn-trash"
              title="Hapus nilai"
              onMouseDown={(e) => {
                e.preventDefault();
                clearScore();
              }}
            >
              <FiTrash2 size={16} color="red" />
            </button>

          </div>
        </div>
      )}


    </>
    
  );
}

